import React from "react";
import LoadingGif from "../../assets/gifs/loading.gif";
import "./LoadingCoverScreen.css";

export const LoadingCoverScreen = () => {
  return (
    <div
      className="loadingBackground"
      id="modalBackground"
      onClick={(e) => e.stopPropagation()}
    >
      <img
        className="modalLoadingSymbol"
        src={LoadingGif}
        alt="Loading..."
      ></img>
    </div>
  );
};
